'use client';

import React from 'react';
import { Box, Stack } from '@mui/material';
import CommonContainer from '@components/CommonContainer';
import { CustomRegistration } from '@components/CustomRegistration';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
export const LSQ_WOOLWICH_REGISTRATION_ID = 'sodicRegistration';
export default function LsqSodicRegistration(props: any) {
  const registrationSection = props?.locale?.section?.find(
    (section: any) => section.type === 'registration' && section.enabled
  );
  if (!registrationSection) return null;
  const { links, leadConfig } = props;
  return (
    <Stack
      component="section"
      className={cn.sodicRegistrationWrapper}
      id={LSQ_WOOLWICH_REGISTRATION_ID}
    >
      <Box className={cn.sodicRegistrationInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.sodicRegistrationBody}>
            <Box className={cn.sodicRegistrationContent}>
              <Box className={cn.sodicRegistrationContent__title}>
                <ParallaxText
                  variant="h2"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    registrationSection?.lsqSodicRegistrationHeading
                  )}
                </ParallaxText>
              </Box>
              <Box className={cn.sodicRegistrationContent__data}>
                <ParallaxText
                  variant="p"
                  animationType="zoomIn"
                  animationDuration={500}
                >
                  {ReactHtmlParser(
                    registrationSection?.lsqSodicRegistrationContent
                  )}
                </ParallaxText>
              </Box>
            </Box>
            <Box className={cn.sodicRegistrationForms}>
              <Box className={cn.registrationFormsInner}>
                <CustomRegistration
                  t={registrationSection}
                  successPopUpLink={links.successPopupRedirection}
                  privacyPolicyLink={links.privacyPolicy}
                  termsAndConditionsLink={links.termsAndConditions}
                  formId={leadConfig.formId}
                  formType={leadConfig.formType}
                  projectName={leadConfig.projectName}
                  variant="modal"
                  className={cn.sodicRegistrationOuter}
                  listClassName={cn.sodicRegistrationList}
                  blockClassName={cn.sodicRegistrationBlock}
                  inputClassName={cn.sodicRegistrationInput}
                  elementClassName={cn.sodicRegistrationElement}
                  submitBlockClassName={cn.sodicRegistrationSubmitBlock}
                  submitClassName={cn.sodicRegistrationButton}
                  marksClassName={cn.sodicRegistrationMarks}
                  wrapperClassName={cn.sodicRegistrationSuccessWrapper}
                  contentClassName={cn.sodicRegistrationSuccessContent}
                  buttonClassName={cn.sodicRegistrationSuccessButton}
                />
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
